























import { computed, PropType, toRef } from 'vue';
import { MediaModel } from '../models/media.model';
import { mediaTypes } from '../enums/mediaTypes';
import VideoThumbnail from '../PageFragments/Media/VideoThumbnail.vue';
import ImageThumbnail from '../PageFragments/Media/ImageThumbnail.vue';
import SoundThumbnail from '../PageFragments/Media/SoundThumbnail.vue';
import { useMediaScan } from '../composables/useMediaScan';
import Button from '../directives/button.js';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';

export default {
  components: { SoundThumbnail, ImageThumbnail, VideoThumbnail },
  directives: { Button },
  props: {
    media: { type: Object as PropType<MediaModel>, required: true },
    overlayText: { type: String, default: '' },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const media = toRef(props, 'media');
    const { scanningText, isMediaDisabled } = useMediaScan(media);
    const hasOverlay = computed(() => props.overlayText.length > 0);

    const handleClick = (event: MouseEvent) => {
      if (isMediaDisabled.value) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      emit('click', event);
    };

    return {
      scanningText,
      isMediaDisabled,
      handleClick,
      ScanningStatusEnum,
      mediaTypes,
      hasOverlay,
    };
  },
};
